import { render, staticRenderFns } from "./InstructionsBox.vue?vue&type=template&id=668901fd&scoped=true&"
import script from "./InstructionsBox.vue?vue&type=script&lang=ts&"
export * from "./InstructionsBox.vue?vue&type=script&lang=ts&"
import style0 from "./InstructionsBox.vue?vue&type=style&index=0&id=668901fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668901fd",
  null
  
)

export default component.exports